"use client";

import Link from "next/link";
import Image from "next/image";
import { DEFAULT_SOCIETY_NAME } from "@/lib/site-settings";
import { defaultSiteSettings, type SiteSettings } from "@/lib/site-settings";
import { useEffect, useState } from "react";
import { ArrowDownRight, CalendarDays, MapPin } from "lucide-react";

export function Hero() {
  const [siteSettings, setSiteSettings] = useState<SiteSettings>(defaultSiteSettings());
  useEffect(() => { void fetch("/api/site-settings", { cache: "no-store" }).then((response) => response.ok ? response.json() : null).then((data) => { if (data?.settings) setSiteSettings(data.settings); }).catch(() => undefined); }, []);
  return (
    <section className="hero">
      <div className="container hero-grid">
        <div className="hero-copy">
          <Link className="hero-location" href={siteSettings.locationUrl} target="_blank" rel="noreferrer"><MapPin size={17} /> {siteSettings.city}</Link>
          <h1>Des ongles soignés.<br />Des tresses qui vous ressemblent.</h1>
          <p className="hero-text">Découvrez les prestations, consultez les réalisations et envoyez votre demande depuis un calendrier pensé pour le téléphone.</p>
          <div className="hero-actions">
            <Link className="button button-primary" href="/rendez-vous"><CalendarDays size={18} /> Prendre rendez-vous</Link>
            <Link className="button button-ghost" href="/realisations">Voir les réalisations <ArrowDownRight size={18} /></Link>
          </div>
          <div className="hero-note"><span /> Réservation sur demande — confirmation après validation</div>
        </div>
        <div className="hero-art" aria-label={`Aperçu de l’univers ${DEFAULT_SOCIETY_NAME}`}>
          <div className="hero-card hero-card-main">
            <Image className="hero-cover-image" src="/images/gallery-2.jpg" alt={`Réalisation nail art ${DEFAULT_SOCIETY_NAME}`} fill sizes="(max-width: 900px) 90vw, 45vw" preload />
          </div>
          <div className="hero-card hero-card-small bottom">
            <span>Sur rendez-vous</span>
            <strong>Wissembourg</strong>
          </div>
        </div>
      </div>
    </section>
  );
}
